import { DefaultLayout } from "src/components/Layout"
import { StoresContainer } from "src/features/stores/components/Stores/StoresContainer"
import Head from "next/head"
import { NextPage } from "next"

const StoresPage: NextPage = () => {
  return (
    <DefaultLayout>
      <Head>
        <title>加盟店の一覧 | for CS</title>
      </Head>
      <StoresContainer />
    </DefaultLayout>
  )
}

export default StoresPage
